import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { useNavigate, useParams } from 'react-router-dom';
import { Container } from '../../../ui/gridSystem';
import { MainSection, CourseNotAvailable, TabsWrapper } from './style';
import routes from '../../../routes';
import {
  CourseActivities,
  CourseSessions,
  CourseComments,
  CourseDocuments,
  CourseOverview,
} from '../../../ui/components';
import {
  COURSE_DETAILS_GET,
  COURSE_DETAILS_RESET,
} from '../../redux/actions/coursedetails';
import CourseHero from '../../../ui/components/Courses/CourseHero';
import Tabs from '../../../ui/atoms/Tabs';
import Breadcrumb from '../../../ui/atoms/Breadcrumb';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import ModalLeaveCourse from '../../../ui/atoms/Modals/ModalLeaveCourse';
import ModalSurvey from '../../../ui/atoms/Modals/ModalSurvey';
import { Text } from '../../../ui/atoms';

const defaultTabs = [
  { value: 'panoramica', label: 'Panoramica', icon: 'graduation-hat-01' },
  { value: 'attività', label: 'Attività', icon: 'puzzle-piece-01' },
  { value: 'sessioni', label: 'Sessioni', icon: 'layers-three-02' },
  {
    value: 'documentazione',
    label: 'Documentazione',
    icon: 'file-06',
  },
  {
    value: 'domande-risposte',
    label: 'Domande e risposte',
    icon: 'message-smile-circle',
  },
];

const CourseDetails = ({
  course_details: data,
  getCourseDetails,
  resetCourseDetails,
}) => {
  const navigate = useNavigate();
  const { course_id, tab_name } = useParams();
  const [tabs, setTabs] = useState(defaultTabs);
  const [activeTab, setActiveTab] = useState(defaultTabs[0]);

  useEffect(() => {
    let newTabs = [...defaultTabs];
    // remove comments tab if needed
    if (!data?.comments_enabled) {
      newTabs = newTabs.filter((t) => t.value !== 'domande-risposte');
    }
    // remove event OR course tab according to typology
    if (data?.typology === 'event') {
      newTabs = newTabs.filter((t) => t.value !== 'attività');
    } else if (data?.typology === 'course') {
      newTabs = newTabs.filter((t) => t.value !== 'sessioni');
    }
    setTabs(newTabs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    if (tab_name) {
      const currentTab = defaultTabs.find((t) => t.value === tab_name);
      if (currentTab) {
        setActiveTab(currentTab);
        return;
      }
    }
    navigate(
      `${routes.courseDetails.path}/${course_id}/${defaultTabs[0].value}`
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab_name]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getCourseDetails({ id: course_id });

    return () => resetCourseDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [course_id]);

  const getCurrentTab = (tab) => {
    switch (tab) {
      case 'attività':
        return <CourseActivities />;
      case 'sessioni':
        return <CourseSessions />;
      case 'documentazione':
        return <CourseDocuments />;
      case 'domande-risposte':
        return <CourseComments />;
      case 'panoramica':
      default:
        return <CourseOverview />;
    }
  };

  return (
    <>
      {!data.contentNotAvailable && (
        <>
          <Breadcrumb
            crumbs={[
              {
                label: 'I miei progressi',
                onClick: () => navigate(routes.dashboard.path),
              },
              { label: data?.title },
            ]}
          />
          <CourseHero />
        </>
      )}
      <Container className="pt-0">
        {/* TABS */}
        <TabsWrapper>
          <Tabs
            tabs={tabs}
            selected={activeTab}
            onChange={({ value }) => {
              navigate(`${routes.courseDetails.path}/${course_id}/${value}`);
            }}
          />
        </TabsWrapper>
        <Container className="p-0">
          {!data.contentNotAvailable ? (
            <MainSection>{getCurrentTab(activeTab?.value)}</MainSection>
          ) : (
            <CourseNotAvailable>
              <Text type="b2" className="text-center">
                Il contenuto non è disponibile
              </Text>
            </CourseNotAvailable>
          )}
        </Container>
      </Container>
      <ModalLeaveCourse />
      <ModalSurvey />
    </>
  );
};

CourseDetails.propTypes = {
  // HOC withMediaQueries
  // HOC (connect, state)
  course_details: PropTypes.object.isRequired,
  // HOC (connect, dispatch)
  getCourseDetails: PropTypes.func.isRequired,
  resetCourseDetails: PropTypes.func.isRequired,
};

export default connect(
  (state) => {
    const course_details = state.coursedetails;
    return {
      course_details,
    };
  },
  (dispatch) => ({
    getCourseDetails: ({ id, hideLoader }) =>
      dispatch({ type: COURSE_DETAILS_GET._REQUEST, id, hideLoader }),
    resetCourseDetails: () => dispatch({ type: COURSE_DETAILS_RESET }),
  })
)(withMediaQueries(CourseDetails));
